import styled from "styled-components";
import { getColor } from "../../../utils/color";
import { ButtonProps } from "../@types/button";

export const ButtonComponent = styled.button<ButtonProps>`
  display: flex;
  flex-direction: row;
  justify-content: ${({ align = "center" }) => align};
  align-items: center;
  padding: 8px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  border: 1px solid ${({ backgroundColor }) => backgroundColor};
  background-color: ${({ backgroundColor, bordered }) =>
    bordered ? "transparent" : backgroundColor};
  color: ${({ backgroundColor, bordered, textColor }) =>
    bordered ? backgroundColor : textColor} !important;

  &:hover,
  &:active {
    &:not([disabled]) {
      background-color: ${({ backgroundColor }) =>
        getColor(backgroundColor).hover};
      border: 1px solid
        ${({ backgroundColor }) => getColor(backgroundColor).hover};
      color: ${({ textColor }) => textColor} !important;
    }
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
    color: ${({ textColor }) => textColor} !important;
    background: ${({ backgroundColor }) => getColor(backgroundColor).main};
  }

  ${({ borderedTextColor }) =>
    borderedTextColor && `color: ${borderedTextColor} !important;`}
  ${({ whiteSpace }) => whiteSpace && `white-space: ${whiteSpace};`}
  ${({ width }) => width && `width: ${width};`}
  ${({ height }) => height && `height: ${height};`}
  ${({ margin }) => margin && `margin: ${margin};`}
  ${({ padding }) => padding && `padding: ${padding};`}
  ${({ svgMargin }) => svgMargin && `svg{margin: ${svgMargin};}`}
  ${({ fontSize }) => fontSize && `font-size: ${fontSize}px;`}
  ${({ fontWeight }) => fontWeight && `font-weight: ${fontWeight};`}
  ${({ lineHeight }) => lineHeight && `line-height: ${lineHeight}px;`};
  ${({ transform }) => transform && `text-transform: ${transform};`};
  ${({ selfAlign }) => selfAlign && `align-self: ${selfAlign};`};
`;
